import { faSearch } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import React, { useState, useRef, useEffect  } from 'react';

const ShopList = ({ shopList, onClose }) => {
  const [searchTerm, setSearchTerm] = useState('');
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const searchInputRef = useRef(null);

  const filteredShops = shopList.filter((shop) =>
    shop.name.toLowerCase().includes(searchTerm.toLowerCase()) || 
    String(shop.shopcode).toLowerCase().includes(searchTerm.toLowerCase())
  );

  const handleSelectShop = (shop) => {
    localStorage.setItem('selectedShop', JSON.stringify(shop));
    window.dispatchEvent(new Event('shopChange'));
    setOpenSnackbar(true);
    onClose();
  };

  useEffect(() => {
    if (searchInputRef.current) {
      searchInputRef.current.focus();
    }
  }, []);

  const handleCloseSnackbar = (event, reason) => {
    if (reason === 'clickaway') return;
    setOpenSnackbar(false);
  };

  return (
    <div 
      className="shop-list-container" 
      onClick={(e) => e.stopPropagation()}
      style={{
        backgroundColor: '#fff',
        padding: '20px',
        borderRadius: '8px',
        maxWidth: '400px',
        width: '95%',
        minHeight: '350px',
        position: 'relative'
      }}
    >
      <div className='text-start pb-2 fs-5'>Shop List</div>

      {/* Search Box */}
      <div className="d-flex pb-2" style={{ maxWidth: '100%', position: 'relative' }}>
        <input
          type="search"
          ref={searchInputRef} 
          className="search-input"
          placeholder="Search Shop"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          style={{
            width: '100%',
            padding: '8px',
            borderRadius: '8px 0 0 8px',
            border: 'none',
            background: '#e0e0e0',
          }}
        />
        <span
          className="input-group-text"
          style={{
            background: '#bdbdbd',
            border: 'none',
            borderRadius: '0 8px 8px 0',
            display: 'flex',
            alignItems: 'center',
            padding: '8px 12px',
            cursor: 'pointer',
          }}
        >
          <FontAwesomeIcon icon={faSearch} style={{ fontSize: '1rem', color: '#757575' }} />
        </span>
      </div>

      {/* Shop List */}
      <div style={{
        width: '100%',
        padding: '8px',
        borderRadius: '4px',
        maxHeight: '200px',
        overflowY: 'auto',
      }}>
        {filteredShops.length > 0 ? (
          filteredShops.map((shop) => (
            <div
              className="text-start p-2 lihovers"
              key={shop.shopcode}
              onClick={() => handleSelectShop(shop)}
              style={{ cursor: 'pointer' }}
            >
              {shop.name} ({shop.shopcode})
            </div>
          ))
        ) : (
          <div className="text-muted">No shops found</div>
        )}
      </div>

      {/* Close Button */}
      <button
        onClick={onClose}
        style={{
          position: 'absolute',
          top: '10px',
          right: '10px',
          background: 'transparent',
          border: 'none',
          fontSize: '20px',
          cursor: 'pointer',
        }}
      >
        &times;
      </button>

      {/* Success Notification */}
      <Snackbar open={openSnackbar} autoHideDuration={4000} onClose={handleCloseSnackbar}>
        <Alert 
          onClose={handleCloseSnackbar} 
          severity="success" 
          variant="filled" 
          sx={{ width: '100%' }}
        >
          Shop Selected Successfully...
        </Alert>
      </Snackbar>
    </div>
  );
};

export default ShopList;